import React, { ReactNode } from 'react';

import PropTypes from 'prop-types';

import { useTheme } from '@adsk/alloy-react-styles';
import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

export type ListRowProps = StylableComponent<HTMLDivElement> & {
  value: ReactNode;
  label: ReactNode;
};

const ListRow = React.forwardRef<HTMLDivElement, ListRowProps>(
  ({ label, value, className, style, ...props }, ref) => {
    const listRowTokens = useTheme().tokens?.component?.activityLog?.listRow;
    const labelTokens = listRowTokens?.label;
    const valueTokens = listRowTokens?.value;

    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            display: 'flex',
            marginBottom: listRowTokens?.marginBottom,
            '&:last-child': {
              marginBottom: 0,
            },
          },
          style,
        ]}
        {...props}
      >
        <div
          dir="auto"
          css={[
            labelTokens,
            {
              width: labelTokens?.width,
              marginRight: labelTokens?.marginRight,
            },
          ]}
        >
          {label}
        </div>
        <div dir="auto" css={[{ flex: 1 }, valueTokens]}>
          {value}
        </div>
      </div>
    );
  },
);

ListRow.displayName = 'ListRow';

ListRow.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
  /** The row label */
  label: PropTypes.any.isRequired,
  /** The row value */
  value: PropTypes.any.isRequired,
};

export default ListRow;
